import { render, staticRenderFns } from "./chiTietNgayPhep.vue?vue&type=template&id=1ec53b48&scoped=true&"
import script from "./chiTietNgayPhep.vue?vue&type=script&lang=js&"
export * from "./chiTietNgayPhep.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ec53b48",
  null
  
)

export default component.exports